import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Spinner from '../Spinner';
import { CTAsWrapper, GroupOfCTAs, ShowResultsCTA, ResetFilters } from './Filters.style';
import useAnimations from '../../hooks/Animations/useAnimations';
import buildQueryParams from '../../hooks/Filters/useUpdateQueryParams';
import {
  clearAllFilters,
  setConfirmaedFilters,
  setDefaultTier3Filters,
  selectFilters,
} from '../../redux/filtersReducer';
import { filtersSave, filtersClear, filterCurrentState } from '../../utils/analyticsEventListeners';
import { selectAppConfig } from '../../redux/appConfigReducer';
import { INTIAL_FILTERS } from '../../constants/initialFilters';

interface CtaGroupProps {
  isFiltersOpen: boolean;
  loading: boolean;
  isLaptop: boolean;
  isReachedEndOfContainer: boolean;
  isVehiclesLoading: boolean;
  setIsFiltersOpen: (arg: boolean) => void;
}

const CtaGroup: React.FC<CtaGroupProps> = ({
  isFiltersOpen,
  loading,
  isLaptop,
  isReachedEndOfContainer,
  isVehiclesLoading,
  setIsFiltersOpen,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { filterCTAAnimationLeft, filterCTAAnimationRight } = useAnimations(isFiltersOpen);
  const { isTier3page, tier3Filters, isUrlParamsDynamic } = useSelector(selectAppConfig);
  const { confirmedFilters } = useSelector(selectFilters);

  const resetAllFilters = () => {
    if (isTier3page) {
      dispatch(setDefaultTier3Filters(tier3Filters));
      if (isUrlParamsDynamic) {
        buildQueryParams(null);
      }
    }
    if (!isTier3page) dispatch(clearAllFilters());
    // Analytics Events - clear all filters
    filtersClear(confirmedFilters);
    // Analytics Events - clear all filters
    filterCurrentState(isTier3page ? tier3Filters : INTIAL_FILTERS);
    // Reload main dealer id
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const confirmFilters = () => {
    if (loading) return;
    // if (isZeroResults) return;
    // FIXME - CHANGE LATER - Maybe we should check to see
    // if there isn't any different between confirmed and temp filters break and return from function
    // dispatch(setConfirmaedFilters({ temporaryFilters, isTier3page }));
    if (isUrlParamsDynamic) buildQueryParams(confirmedFilters);
    // Data Layer Event - Filter Panel Save
    // filtersSave(temporaryFilters, (totalCount as number) || null);
    // Scroll on top after confirming filters
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    // Flag responsible for handling data layer events => Filter Panel Save & Results Returned
    if (!isLaptop) {
      setIsFiltersOpen(false);
    }
  };

  const isLoading = isVehiclesLoading || loading;

  return (
    <CTAsWrapper
      style={isLaptop ? filterCTAAnimationLeft : filterCTAAnimationRight}
      $isReachedEndOfContainer={isReachedEndOfContainer}
    >
      <GroupOfCTAs>
        <ShowResultsCTA onClick={confirmFilters} data-testid="show-results-cta">
          {t('vlp.filters.finishAndClose')}
        </ShowResultsCTA>
        <ResetFilters
          isLoading={isLoading}
          onClick={resetAllFilters}
          data-testid="reset-filters-cta"
        >
          {t('vlp.filters.resetFilters')}
        </ResetFilters>
      </GroupOfCTAs>
    </CTAsWrapper>
  );
};

export default CtaGroup;
